(function($, window, undefined) {
	'use strict';

	App.EscolherEstado = {};


	App.EscolherEstado.RemoverScroll = function () {
		$('body').css('overflow', 'hidden');
	};

	App.EscolherEstado.NormalizarScroll = function () {
	    $('body').css({ 'overflow-x': 'hidden', 'overflow-y':'scroll' });
	};

	App.EscolherEstado.SetarTamanho = function () {
		var
		windowWidth = $(window).width(),
		windowHeight = $(window).height();

		if (windowHeight <= 320) {
			$('.escolher-estado-modal').width(windowWidth).height(windowHeight);
		} else {
			$('.escolher-estado-modal').width(windowWidth).height(windowHeight);
		}
	};


	App.EscolherEstado.SetCookie = function (cname, cvalue, exdays) {

	        var d = new Date();
	        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	        var expires = 'expires=' + d.toUTCString();
	        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	    
	};

	App.EscolherEstado.GetCookie = function (cname) {
	    var name = cname + '=';
	    var ca = document.cookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}

	App.EscolherEstado.CheckCookie = function (cname) {
	    var CookieName = App.EscolherEstado.GetCookie(cname);
	    if (CookieName != '') {
	        return true;
	    } else {
	        return false;
	    }
	}


	App.EscolherEstado.Abrir = function () {
	    $('.escolher-estado-modal, .escolher-estado-overlay').fadeIn();
	    App.EscolherEstado.RemoverScroll();
	    App.EscolherEstado.SetarTamanho();
	};

	App.EscolherEstado.Fechar = function () {
	    $('.escolher-estado-modal, .escolher-estado-overlay').fadeOut();
	    App.EscolherEstado.NormalizarScroll();
	    App.EscolherEstado.SetarTamanho();
	};

	setTimeout(function () {
		App.EscolherEstado.SetarTamanho();
	});

	$(window).resize(function () {
		setTimeout(function () {
		    App.EscolherEstado.SetarTamanho();
		   
		});
	});

	$(document).on('touchmove mousewheel DOMMouseScroll', '.escolher-estado-modal, .escolher-estado-overlay', function (e) {
		e.preventDefault();
	});

	if (window.location.hash == '#sp') {
	    App.EscolherEstado.SetCookie('estadoName', 'São Paulo', 365);
	    App.EscolherEstado.SetCookie('estado', 'SP', 365);
	}


	if(!App.EscolherEstado.CheckCookie('estado')){

	    if(!window.location.hash == '#sp') {
	        App.EscolherEstado.Abrir();
        }

	}

	if (App.EscolherEstado.CheckCookie('estado')) {
	    var estadoName = App.EscolherEstado.GetCookie('estadoName');
	    $('.estado-change .estado-selected').text(estadoName);
	}

	$('.box-acoes .estado-change').on('click', function () {
	    App.EscolherEstado.Abrir();
	    return false;
	});

	$('.escolher-estado-modal form').on('submit', function () {
	    var estado = ($(this).find('.estado').val());
	    var estadoName = ($(this).find('.estado option:selected').text());
	    $('.estado-change .estado-selected').text(estadoName);
	    App.EscolherEstado.SetCookie('estadoName', estadoName, 365);
	    App.EscolherEstado.SetCookie('estado', estado, 365);
	    if (estado == '') {
	        $('.escolher-estado-modal form').addClass('animated shake');
	        setTimeout(function () {
	            $('.escolher-estado-modal form').removeClass('animated shake');
	        }, 1000);
        } else {
	        App.EscolherEstado.Fechar();
	    }
	    return false;

	});

	

	
}(jQuery, window));